// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  overflow-x: auto;
  margin-top: 20px;
}

.TimelineText {
  color: white;
  font-weight: 500;
  font-size: 18px;
  padding: 0;
  margin: 0;
  padding-left: 2px;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #ddd;
}

th {
  background-color: #b6dde8;
  text-align: center;
  padding: 12px;
  font-weight: bold;
  font-size: 18px;
  border: 1px solid black;
}

.valueBackground {
  background-color: #d9d9d9;
  color: black;
}

td {
  border: 1px solid #ddd;
  padding: 12px;
  color: #2c2b2b;
  opacity: 1;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}

@media (max-width: 768px) {
  table {
    font-size: 8px;
  }

  th,
  td {
    padding: 8px;
    font-size: 7px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/project/components/dark_version/ProjectDetails/ProjectTimelineStyle.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,YAAY;IACZ,cAAc;EAChB;AACF","sourcesContent":[".table-container {\n  overflow-x: auto;\n  margin-top: 20px;\n}\n\n.TimelineText {\n  color: white;\n  font-weight: 500;\n  font-size: 18px;\n  padding: 0;\n  margin: 0;\n  padding-left: 2px;\n}\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  border: 1px solid #ddd;\n}\n\nth {\n  background-color: #b6dde8;\n  text-align: center;\n  padding: 12px;\n  font-weight: bold;\n  font-size: 18px;\n  border: 1px solid black;\n}\n\n.valueBackground {\n  background-color: #d9d9d9;\n  color: black;\n}\n\ntd {\n  border: 1px solid #ddd;\n  padding: 12px;\n  color: #2c2b2b;\n  opacity: 1;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: left;\n}\n\n@media (max-width: 768px) {\n  table {\n    font-size: 8px;\n  }\n\n  th,\n  td {\n    padding: 8px;\n    font-size: 7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
